import { Component, OnInit, AfterViewInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, Form} from '@angular/forms';

import { ItemService } from '../../../service/item/item.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { UnitService } from '../../../service/unit/unit.service';
import { AbcService } from '../../../service/abc/abc.service';
import { CaseService } from '../../../service/case/case.service';
import { TypeunitpriceService } from '../../../service/typeunitprice/typeunitprice.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { TypeItemService } from 'app/service/type-item/type-item.service';

@Component({
  selector: 'wa9101',
  templateUrl: 'wa9101.component.html',
  styleUrls: ['wa9101.component.scss']
})

export class Wa9101Component implements OnInit, AfterViewInit {
  public componentTitle = 'WA9101:商品マスタ登録';

  public typecolds: any
  public units: any
  public owners: any
  public abcs: any;
  public cases: any;
  public typeunitprices: any;
  public typeitems: object;

  public ownerId: FormControl;
  public ownerTx: string;
  public itemId: number;
  public itemCd: FormControl;
  public itemTx: FormControl;
  public lotFl = 0;
  public typeitemCd: FormControl;
  public sameitemapplyFl = 0;
  public typecoldCd: FormControl;
  public uselimitFl = 0;
  public fragilemarkFl = 0;
  public upwardmarkFl = 0;
  public itemlabeluseFl = 0;
  public arrivlabeluseFl = 0;
  public shiplabeluseFl = 0;
  public arriveuselimitNr: FormControl;
  public shipuselimitNr: FormControl;
  public unitId: FormControl;
  public unitTx: string
  public itemabcId: FormControl;
  public caseCd: FormControl;
  public baraamountNr: FormControl;
  public pycaseCd: FormControl;            // ケース入り標準ケースコード(通常)
  public pycaseamountNr: FormControl;      // ケース入り標準ケース入数(通常)
  public bybaracaseCd: FormControl;        // バラ入り標準ケースコード(保管)
  public bybaracaseamountNr: FormControl;  // バラ入り標準ケース入数(保管)
  public bycaseCd: FormControl;            // ケース入り標準ケースコード(保管)
  public bycaseamountNr: FormControl;      // ケース入り標準ケース入数(保管)
  public maxpbinstockNr: FormControl;
  public inneramountNr: FormControl;
  public innerNr: FormControl;
  public caseamountNr: FormControl;
  public casespreadNr: FormControl;
  public casestackNr: FormControl;
  public pcsbarcodeTx: FormControl;
  public casebarcodeTx: FormControl;
  public lengthNr: FormControl;
  public widthNr: FormControl;
  public heightNr: FormControl;
  public volumeNr: FormControl;
  public weightNr: FormControl;
  public innerlengthNr: FormControl;
  public innerwidthNr: FormControl;
  public innerheightNr: FormControl;
  public caselengthNr: FormControl;
  public casewidthNr: FormControl;
  public caseheightNr: FormControl;
  public casevolumeNr: FormControl;
  public caseweightNr: FormControl;
  public typeunitpriceCd: FormControl;
  public stockunitpriceNr: FormControl;
  public arriveunitpriceNr: FormControl;
  public shipunitpriceNr: FormControl;
  public depositpriceNr: FormControl;
  public bsupppointbaraNr: FormControl;       // 補充点(バラ・通常)
  public bsupplimitbaraNr: FormControl;       // 上限値(バラ・通常)
  public supppointinnercaseNr: FormControl;   // 補充点(インナーケース・通常)
  public supplimitinnercaseNr: FormControl;  // 上限値(インナーケース・通常)
  public supppointcaseNr: FormControl;        // 補充点(ケース・通常)
  public supplimitcaseNr: FormControl;        // 上限値(ケース・通常)
  public variation1Tx: FormControl;
  public variation2Tx: FormControl;
  public variation3Tx: FormControl;
  public displaypriceNr: FormControl;
  public selectedOwnerId;
  public ownerResult;
  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Input() selectedownerId;
  private isDelayHide = true;

  private errorInfo = '';
  private isArrivlabeluseFl = false; // MA_OWNERFUNCTIONにて、選択した荷主の入荷ラベル運用フラグが1であればtrue
  private isShiplabeluseFl = false; // MA_OWNERFUNCTIONにて、選択した荷主の出荷ラベル運用フラグが1であればtrue
  private isUselimitDisabled = false;

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  readonly STRINGS_ACTIVE = 'active';
  public ownerIdCls = '';
  public itemCdCls = '';
  public itemTxCls = '';
  public lotFlCls = '';
  public typeitemCdCls = '';
  public sameitemapplyFlCls = '';
  public typecoldCdCls = '';
  public uselimitFlCls = '';
  public fragilemarkFlCls = '';
  public upwardmarkFlCls = '';
  public itemlabeluseFlCls = '';
  public arriveuselimitNrCls = '';
  public shipuselimitNrCls = '';
  public unitIdCls = '';
  public unitTxCls = '';
  public itemabcIdCls = '';
  public caseCdCls = '';
  public baraamountNrCls = '';
  public pycaseCdCls = '';
  public pycaseamountNrCls = '';
  public bybaracaseCdCls = '';
  public bybaracaseamountNrCls = '';
  public bycaseCdCls = '';
  public bycaseamountNrCls = '';
  public maxpbinstockNrCls = '';
  public inneramountNrCls = '';
  public innerNrCls = '';
  public caseamountNrCls = '';
  public casespreadNrCls = '';
  public casestackNrCls = '';
  public pcsbarcodeTxCls = '';
  public casebarcodeTxCls = '';
  public lengthNrCls = '';
  public widthNrCls = '';
  public heightNrCls = '';
  public volumeNrCls = '';
  public weightNrCls = '';
  public innerlengthNrCls = '';
  public innerwidthNrCls = '';
  public innerheightNrCls = '';
  public caselengthNrCls = '';
  public casewidthNrCls = '';
  public caseheightNrCls = '';
  public casevolumeNrCls = '';
  public caseweightNrCls = '';
  public typeunitpriceCdCls = '';
  public stockunitpriceNrCls = '';
  public arriveunitpriceNrCls = '';
  public shipunitpriceNrCls = '';
  public depositpriceNrCls = '';
  public bsupppointbaraNrCls = '';
  public bsupplimitbaraNrCls = '';
  public supppointinnercaseNrCls = '';
  public supplimitinnercaseNrCls = '';
  public supppointcaseNrCls = '';
  public supplimitcaseNrCls = '';
  public variation1TxCls = '';
  public variation2TxCls = '';
  public variation3TxCls = '';
  public displaypriceNrCls = '';

  private isSubmitButtonEnabled = false;
  private tabIndex = 0;
  private anchors = [0, 570, 2365, 2479, 2579];

  constructor(
    private router: Router,
    private itemService: ItemService,
    private ownerService: OwnerService,
    private typeColdService: TypeColdService,
    private unitService: UnitService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private abcService: AbcService,
    private caseService: CaseService,
    private typeunitpriceService: TypeunitpriceService,
    private typeitemService: TypeItemService,
  ) {
    this.ownerId = new FormControl('', [
      Validators.required,
    ]),
      this.itemCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.itemCd.maxLength),
      ]),
      this.itemTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.itemTx.maxLength),
      ]),
      this.arriveuselimitNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.arriveuselimitNr.maxNr),
        Validators.min(validation.arriveuselimitNr.minNr),
      ]),
      this.shipuselimitNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.shipuselimitNr.maxNr),
        Validators.min(validation.shipuselimitNr.minNr),
      ]),
      this.typecoldCd = new FormControl('', [
        Validators.required,
      ]),
      this.typeitemCd = new FormControl(''),
      this.unitId = new FormControl('', [
        Validators.required,
      ]),
      this.itemabcId = new FormControl('', [
        Validators.required,
      ]),
      this.caseCd = new FormControl('', [
        Validators.required,
      ]),
      this.baraamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.baraamountNr.maxNr),
        Validators.min(validation.baraamountNr.minNr),
      ]),
      this.pycaseCd = new FormControl('', [
        Validators.required,
      ]),
      this.pycaseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.pycaseamountNr.maxNr),
        Validators.min(validation.pycaseamountNr.minNr),
      ]),
      this.bybaracaseCd = new FormControl('', [
        Validators.required,
      ]),
      this.bybaracaseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.bybaracaseamountNr.maxNr),
        Validators.min(validation.bybaracaseamountNr.minNr),
      ]),
      this.bycaseCd = new FormControl('', [
        Validators.required,
      ]),
      this.bycaseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.bycaseamountNr.maxNr),
        Validators.min(validation.bycaseamountNr.minNr),
      ]),
      this.maxpbinstockNr = new FormControl(99999, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.maxpbinstockNr.maxNr),
        Validators.min(validation.maxpbinstockNr.minNr),
      ]),
      this.inneramountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.inneramountNr.maxNr),
        Validators.min(validation.inneramountNr.minNr),
      ]),
      this.innerNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.innerNr.maxNr),
        Validators.min(validation.innerNr.minNr),
      ]),
      this.caseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.caseamountNr.maxNr),
        Validators.min(validation.caseamountNr.minNr),
      ]),
      this.casespreadNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.casespreadNr.maxNr),
        Validators.min(validation.casespreadNr.minNr),
      ]),
      this.casestackNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.casestackNr.maxNr),
        Validators.min(validation.casestackNr.minNr),
      ]),
      this.pcsbarcodeTx = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        // Validators.pattern(validation.code39),
        Validators.maxLength(validation.pcsbarcodeTx.maxLength),
      ]),
      this.casebarcodeTx = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        // Validators.pattern(validation.code39),
        Validators.maxLength(validation.casebarcodeTx.maxLength),
      ]),
      this.lengthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.lengthNr.maxNr),
        Validators.min(validation.lengthNr.minNr),
      ]),
      this.widthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.widthNr.maxNr),
        Validators.min(validation.widthNr.minNr),
      ]),
      this.heightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.heightNr.maxNr),
        Validators.min(validation.heightNr.minNr),
      ]),
      this.volumeNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.volumeNr.maxNr),
        Validators.min(validation.volumeNr.minNr),
      ]),
      this.weightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.weightNr.maxNr),
        Validators.min(validation.weightNr.minNr),
      ]),
      this.innerlengthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.innerlengthNr.maxNr),
        Validators.min(validation.innerlengthNr.minNr),
      ]),
      this.innerwidthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.innerwidthNr.maxNr),
        Validators.min(validation.innerwidthNr.minNr),
      ]),
      this.innerheightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.innerheightNr.maxNr),
        Validators.min(validation.innerheightNr.minNr),
      ]),
      this.caselengthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.caselengthNr.maxNr),
        Validators.min(validation.caselengthNr.minNr),
      ]),
      this.casewidthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.casewidthNr.maxNr),
        Validators.min(validation.casewidthNr.minNr),
      ]),
      this.caseheightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.caseheightNr.maxNr),
        Validators.min(validation.caseheightNr.minNr),
      ]),
      this.casevolumeNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.casevolumeNr.maxNr),
        Validators.min(validation.casevolumeNr.minNr),
      ]),
      this.caseweightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.caseweightNr.maxNr),
        Validators.min(validation.caseweightNr.minNr),
      ]),
      this.typeunitpriceCd = new FormControl('', [
        Validators.required,
      ]),
      this.stockunitpriceNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.stockunitpriceNr.maxNr),
        Validators.min(validation.stockunitpriceNr.minNr),
      ]),
      this.arriveunitpriceNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.arriveunitpriceNr.maxNr),
        Validators.min(validation.arriveunitpriceNr.minNr),
      ]),
      this.shipunitpriceNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.shipunitpriceNr.maxNr),
        Validators.min(validation.shipunitpriceNr.minNr),
      ]),
      this.depositpriceNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.depositpriceNr.maxNr),
        Validators.min(validation.depositpriceNr.minNr),
      ]),
      this.bsupppointbaraNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.bsupppointbaraNr.maxNr),
        Validators.min(validation.bsupppointbaraNr.minNr),
      ]),
      this.bsupplimitbaraNr = new FormControl(9999, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.bsupplimitbaraNr.maxNr),
        Validators.min(validation.bsupplimitbaraNr.minNr),
      ]),
      this.supppointinnercaseNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.supppointinnercaseNr.maxNr),
        Validators.min(validation.supppointinnercaseNr.minNr),
      ]),
      this.supplimitinnercaseNr = new FormControl(9999, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.supplimitinnercaseNr.maxNr),
        Validators.min(validation.supplimitinnercaseNr.minNr),
      ]),
      this.supppointcaseNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.supppointcaseNr.maxNr),
        Validators.min(validation.supppointcaseNr.minNr),
      ]),
      this.supplimitcaseNr = new FormControl(9999, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.supplimitcaseNr.maxNr),
        Validators.min(validation.supplimitcaseNr.minNr),
      ]),
      this.variation1Tx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.variation1Tx.maxLength),
      ]),
      this.variation2Tx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.variation2Tx.maxLength),
      ]),
      this.variation3Tx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.variation3Tx.maxLength),
      ]),
      this.displaypriceNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.displaypriceNr.maxNr),
        Validators.min(validation.displaypriceNr.minNr),
      ]),

      this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    // TODO should be execute parallel, but API server don't work properly
    this.ownerService
      .get()
      .then(outputJson => {
        try {
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
          if (JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {

            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === JSON.parse(sessionStorage.getItem('ownerResult')).ownerId) return true;
            });
            this.selectedownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
            this.ownerId.setValue(JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx);
            this.ownerResult = sessionStorage.getItem('ownerResult');

          } else {
            this.owners = outputJson.owners;
            this.selectedownerId = null;
            this.ownerResult = sessionStorage.getItem('ownerResult');

            this.ownerId.setValue('');

          }
        } catch (error) {
          this.selectedownerId = null;
        }
        this.typeColdService
          .get()
          .then(_outputJson => {
            this.typecolds = _outputJson.typecolds;
            this.unitService
              .get()
              .then(__outputJson => {
                this.working = false;
                this.units = __outputJson.units;
              })
              .catch(error => {
                this.working = false;
                this.errorInfo = this.commonService.getErrorMessage(error);
              });
          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.abcService
      .get()
      .then(__outputJson => {
        this.abcs = __outputJson.abcs;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.caseService
      .get()
      .then(__outputJson => {
        this.cases = __outputJson.cases;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typeunitpriceService
      .get()
      .then(__outputJson => {
        this.typeunitprices = __outputJson.typeunitprices;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typeitemService
      .get()
      .then(___outputJson => {
        this.typeitems = ___outputJson.itemcategories;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    var itemCd = this.itemCd.value.trim();
    var itemTx = this.itemTx.value.trim();
    var variation1Tx = this.variation1Tx.value.trim();
    var variation2Tx = this.variation2Tx.value.trim();
    var variation3Tx = this.variation3Tx.value.trim();
    var pcsbarcodeTx = this.pcsbarcodeTx.value.trim();
    var casebarcodeTx = this.casebarcodeTx.value.trim();

    let errors = false;
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.itemCd.errors !== null) {
      this.itemCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.itemTx.errors !== null) {
      this.itemTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.arriveuselimitNr.errors !== null) {
      this.arriveuselimitNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shipuselimitNr.errors !== null) {
      this.shipuselimitNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeitemCd.errors !== null) {
      this.typeitemCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typecoldCd.errors !== null) {
      this.typecoldCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.unitId.errors !== null) {
      this.unitId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.itemabcId.errors !== null) {
      this.itemabcId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseCd.errors !== null) {
      this.caseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.baraamountNr.errors !== null) {
      this.baraamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pycaseCd.errors !== null) {
      this.pycaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pycaseamountNr.errors !== null) {
      this.pycaseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bybaracaseCd.errors !== null) {
      this.bybaracaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bybaracaseamountNr.errors !== null) {
      this.bybaracaseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bycaseCd.errors !== null) {
      this.bycaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bycaseamountNr.errors !== null) {
      this.bycaseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.maxpbinstockNr.errors !== null) {
      this.maxpbinstockNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.inneramountNr.errors !== null) {
      this.inneramountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerNr.errors !== null) {
      this.innerNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseamountNr.errors !== null) {
      this.caseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casespreadNr.errors !== null) {
      this.casespreadNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casestackNr.errors !== null) {
      this.casestackNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pcsbarcodeTx.errors !== null) {
      this.pcsbarcodeTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casebarcodeTx.errors !== null) {
      this.casebarcodeTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.lengthNr.errors !== null) {
      this.lengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.widthNr.errors !== null) {
      this.widthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.heightNr.errors !== null) {
      this.heightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.volumeNr.errors !== null) {
      this.volumeNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.weightNr.errors !== null) {
      this.weightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerlengthNr.errors !== null) {
      this.innerlengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerwidthNr.errors !== null) {
      this.innerwidthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerheightNr.errors !== null) {
      this.innerheightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caselengthNr.errors !== null) {
      this.caselengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casewidthNr.errors !== null) {
      this.casewidthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseheightNr.errors !== null) {
      this.caseheightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casevolumeNr.errors !== null) {
      this.casevolumeNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseweightNr.errors !== null) {
      this.caseweightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeunitpriceCd.errors !== null) {
      this.typeunitpriceCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.stockunitpriceNr.errors !== null) {
      this.stockunitpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.arriveunitpriceNr.errors !== null) {
      this.arriveunitpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.depositpriceNr.errors !== null) {
      this.depositpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bsupppointbaraNr.errors !== null) {
      this.bsupppointbaraNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bsupplimitbaraNr.errors !== null) {
      this.bsupplimitbaraNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supppointinnercaseNr.errors !== null) {
      this.supppointinnercaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supplimitinnercaseNr.errors !== null) {
      this.supplimitinnercaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supppointcaseNr.errors !== null) {
      this.supppointcaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supplimitcaseNr.errors !== null) {
      this.supplimitcaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.variation1Tx.errors !== null) {
      this.variation1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.variation2Tx.errors !== null) {
      this.variation2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.variation3Tx.errors !== null) {
      this.variation3Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.displaypriceNr.errors !== null) {
      this.displaypriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    if (this.innerNr.value == 0) {
      if (this.inneramountNr.value != 1) {
        //インナーケースが存在しない場合、インナーケース数=1、となること
        this.errorInfo = 'インナーケースが存在しない場合、インナーケース入数は1としてしてください。';
        return;
      }
    } else {
      if (this.caseamountNr.value != this.inneramountNr.value * this.innerNr.value) {
        //ケース数＝インナーケース入数×インナーケース数、となること
        this.errorInfo = 'インナーケースが存在する場合、ケース入数＝インナーケース入数×インナーケース数となるよう入力してください。';
        return;
      }
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    let ownerIdValue = this.selectedOwnerId ? this.selectedOwnerId : this.ownerId.value;
    console.log('アイテム情報'+this.typeitemCd.value + this.sameitemapplyFl)
    this.itemService
      .post(
        ownerIdValue,
        itemCd,
        itemTx,
        this.lotFl,
        this.uselimitFl,
        this.fragilemarkFl,
        this.upwardmarkFl,
        this.itemlabeluseFl,
        this.arrivlabeluseFl,
        this.shiplabeluseFl,
        this.typeitemCd.value,
        this.sameitemapplyFl,
        this.typecoldCd.value,
        this.arriveuselimitNr.value,
        this.shipuselimitNr.value,
        this.unitId.value,
        this.itemabcId.value,
        this.caseCd.value,
        this.baraamountNr.value,
        this.pycaseCd.value,
        this.pycaseamountNr.value,
        this.bybaracaseCd.value,
        this.bybaracaseamountNr.value,
        this.bycaseCd.value,
        this.bycaseamountNr.value,
        // this.maxpbinstockNr.value,
        this.inneramountNr.value,
        this.innerNr.value,
        this.caseamountNr.value,
        this.casespreadNr.value,
        this.casestackNr.value,
        pcsbarcodeTx,
        casebarcodeTx,
        this.lengthNr.value,
        this.widthNr.value,
        this.heightNr.value,
        this.volumeNr.value,
        this.weightNr.value,
        this.innerlengthNr.value,
        this.innerwidthNr.value,
        this.innerheightNr.value,
        this.caselengthNr.value,
        this.casewidthNr.value,
        this.caseheightNr.value,
        this.casevolumeNr.value,
        this.caseweightNr.value,
        this.typeunitpriceCd.value,
        this.stockunitpriceNr.value,
        this.arriveunitpriceNr.value,
        this.shipunitpriceNr.value,
        this.depositpriceNr.value,
        this.bsupppointbaraNr.value,
        this.bsupplimitbaraNr.value,
        this.supppointinnercaseNr.value,
        this.supplimitinnercaseNr.value,
        this.supppointcaseNr.value,
        this.supplimitcaseNr.value,
        variation1Tx,
        variation2Tx,
        variation3Tx,
        this.displaypriceNr.value,
        'wa9101'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  reflectBarcode(event: string) {
    this.errorInfo = '';

    this.working = true;
    if (event.trim() !== '') {
      this.pcsbarcodeTx.setValue(event.trim())
    }
    this.working = false;
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
      let selectedOwnerTx;
      this.ownerService
        .get()
        .then(outputJson => {
          if (this.selectedownerId) {
            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === this.selectedownerId) {
                this.selectedOwnerId = item.ownerId;
                selectedOwnerTx = item.ownerTx;
                return true;
              }
            });
            this.ownerId.setValue(selectedOwnerTx);
          } else {
            this.owners = outputJson.owners;
            this.ownerId.setValue('');
          }
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  initDatas() {
    this.itemCd.setValue('');
    this.itemTx.setValue('');
    this.arriveuselimitNr.setValue(0);
    this.shipuselimitNr.setValue(0);
    this.typecoldCd.setValue('10');
    this.typeitemCd.setValue('');
    this.unitId.setValue(1);
    this.itemabcId.setValue(0);
    this.caseCd.setValue('999');
    this.baraamountNr.setValue(1);
    this.pycaseCd.setValue('999');
    this.pycaseamountNr.setValue(1);
    this.bybaracaseCd.setValue('999');
    this.bybaracaseamountNr.setValue(1);
    this.bycaseCd.setValue('999');
    this.bycaseamountNr.setValue(1);
    this.maxpbinstockNr.setValue(99999);
    this.inneramountNr.setValue(1);
    this.innerNr.setValue(0);
    this.caseamountNr.setValue(1);
    this.casespreadNr.setValue(1);
    this.casestackNr.setValue(1);
    this.pcsbarcodeTx.setValue('');
    this.casebarcodeTx.setValue('');
    this.lengthNr.setValue(0);
    this.widthNr.setValue(0);
    this.heightNr.setValue(0);
    this.volumeNr.setValue(0);
    this.weightNr.setValue(0);
    this.innerlengthNr.setValue(0);
    this.innerwidthNr.setValue(0);
    this.innerheightNr.setValue(0);
    this.caselengthNr.setValue(0);
    this.casewidthNr.setValue(0);
    this.caseheightNr.setValue(0);
    this.casevolumeNr.setValue(0);
    this.caseweightNr.setValue(0);
    this.typeunitpriceCd.setValue('10');
    this.stockunitpriceNr.setValue(0);
    this.arriveunitpriceNr.setValue(0);
    this.shipunitpriceNr.setValue(0);
    this.depositpriceNr.setValue(0);
    this.bsupppointbaraNr.setValue(0);
    this.bsupplimitbaraNr.setValue(9999);
    this.supppointinnercaseNr.setValue(0);
    this.supplimitinnercaseNr.setValue(9999);
    this.supppointcaseNr.setValue(0);
    this.supplimitcaseNr.setValue(9999);
    this.variation1Tx.setValue('');
    this.variation2Tx.setValue('');
    this.variation3Tx.setValue('');
    this.displaypriceNr.setValue(0);
    this.arrivlabeluseFl = 0;
    this.shiplabeluseFl = 0;
    this.isSubmitButtonEnabled = false;
    this.isArrivlabeluseFl = false;
    this.isShiplabeluseFl = false;
    this.sameitemapplyFl = 0;
    this.fragilemarkFl = 0;
    this.upwardmarkFl = 0;
    this.itemlabeluseFl = 0;

    setTimeout(() => {
      this.scrollContent.nativeElement.scrollTop = 0;
      this.changeOwnerId();
    }, 200);
  }

  changeTab(idx) {
    let position = this.anchors[0];
    switch (idx) {
      case 1:
        position = this.anchors[1];
        break;
      case 2:
        // 選択した荷主の入荷ラベル運用フラグ/出荷ラベル運用フラグに応じてpositionを変更する
        if(this.isArrivlabeluseFl && this.isShiplabeluseFl){
          position = this.anchors[4];
        }else if(this.isArrivlabeluseFl || this.isShiplabeluseFl){
          position = this.anchors[3];
        }else{
          position = this.anchors[2];
        }
        break;
    }
    this.tabIndex = idx;
    this.scrollContent.nativeElement.scrollTop = position;
  }

  ngDoCheck() {

    if (!this.isShow)
      return;

    if (sessionStorage.getItem('isWa9101FirstOpen') != null) {
      sessionStorage.removeItem('isWa9101FirstOpen');
      this.onView();
    }

    if(this.caseCd.value === '999') {
      this.baraamountNr.disable();
      this.baraamountNr.setValue('1');
    } else this.baraamountNr.enable();

    if(this.pycaseCd.value === '999') {
      this.pycaseamountNr.disable();
      this.pycaseamountNr.setValue('1');
    } else this.pycaseamountNr.enable();

    if(this.bybaracaseCd.value === '999') {
      this.bybaracaseamountNr.disable();
      this.bybaracaseamountNr.setValue('1');
    } else this.bybaracaseamountNr.enable();

    if(this.bycaseCd.value === '999') {
      this.bycaseamountNr.disable();
      this.bycaseamountNr.setValue('1');
    } else this.bycaseamountNr.enable();

    if(this.uselimitFl == 0) {
      this.arriveuselimitNr.disable();
      this.shipuselimitNr.disable();
      this.arriveuselimitNr.setValue('0');
      this.shipuselimitNr.setValue('0');
    } else {
      this.arriveuselimitNr.enable();
      this.shipuselimitNr.enable();
    }

    if ((this.lengthNr.value + '').length == 0)
      this.lengthNr.setValue(0);

    if ((this.widthNr.value + '').length == 0)
      this.widthNr.setValue(0);

    if ((this.heightNr.value + '').length == 0)
      this.heightNr.setValue(0);

    if ((this.volumeNr.value + '').length == 0)
      this.volumeNr.setValue(0);

    if ((this.weightNr.value + '').length == 0)
      this.weightNr.setValue(0);

    if ((this.innerlengthNr.value + '').length == 0)
      this.innerlengthNr.setValue(0);

    if ((this.innerwidthNr.value + '').length == 0)
      this.innerwidthNr.setValue(0);

    if ((this.innerheightNr.value + '').length == 0)
      this.innerheightNr.setValue(0);

    if ((this.caselengthNr.value + '').length == 0)
      this.caselengthNr.setValue(0);

    if ((this.casewidthNr.value + '').length == 0)
      this.casewidthNr.setValue(0);

    if ((this.caseheightNr.value + '').length == 0)
      this.caseheightNr.setValue(0);

    if ((this.casevolumeNr.value + '').length == 0)
      this.casevolumeNr.setValue(0);

    if ((this.weightNr.value + '').length == 0)
      this.weightNr.setValue(0);


    this.ownerIdCls = this.ownerId.disabled ? 'disabled' : this.ownerId.value === '' ? '' : this.STRINGS_ACTIVE;
    this.itemCdCls = this.itemCd.value === '' ? '' : (this.itemCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.itemTxCls = this.itemTx.value === '' ? '' : (this.itemTx.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.lotFlCls = this.lotFl == 0 ? '' : this.STRINGS_ACTIVE;
    this.fragilemarkFlCls = this.fragilemarkFl === 0 ? '' : this.STRINGS_ACTIVE;
    this.upwardmarkFlCls = this.upwardmarkFl === 0 ? '' : this.STRINGS_ACTIVE;
    this.sameitemapplyFlCls = this.sameitemapplyFl === 0 ? '' : this.STRINGS_ACTIVE;
    this.itemlabeluseFlCls = this.itemlabeluseFl === 0 ? '' : this.STRINGS_ACTIVE;
    this.typeitemCdCls = this.typeitemCd.value === '' ? '' : (this.typeitemCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.typecoldCdCls = this.typecoldCd.value === '10' ? '' : (this.typecoldCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.uselimitFlCls = this.uselimitFl == 0 ? '' : this.STRINGS_ACTIVE;
    this.arriveuselimitNrCls = this.arriveuselimitNr.value + '' === '0' ? '' : (this.arriveuselimitNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.shipuselimitNrCls = this.shipuselimitNr.value + '' === '0' ? '' : (this.shipuselimitNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.unitIdCls = this.unitId.value + '' === '1' ? '' : (this.unitId.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.unitTxCls = this.unitTx === '' ? '' : this.STRINGS_ACTIVE;
    this.itemabcIdCls = this.itemabcId.value + '' === '0' ? '' : (this.itemabcId.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.caseCdCls = this.caseCd.value === '999' ? '' : (this.caseCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.baraamountNrCls = this.baraamountNr.value + '' === '1' ? '' : (this.baraamountNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.pycaseCdCls = this.pycaseCd.value === '999' ? '' : (this.pycaseCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.pycaseamountNrCls = this.pycaseamountNr.value + '' === '1' ? '' : (this.pycaseamountNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.bybaracaseCdCls = this.bybaracaseCd.value === '999' ? '' : (this.bybaracaseCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.bybaracaseamountNrCls = this.bybaracaseamountNr.value + '' === '1' ? '' : (this.bybaracaseamountNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.bycaseCdCls = this.bycaseCd.value === '999' ? '' : (this.bycaseCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.bycaseamountNrCls = this.bycaseamountNr.value + '' === '1' ? '' : (this.bycaseamountNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    // this.maxpbinstockNrCls = this.maxpbinstockNr.value + '' === '99999' ? '' : (this.maxpbinstockNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.inneramountNrCls = this.inneramountNr.value + '' === '1' ? '' : (this.inneramountNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.innerNrCls = this.innerNr.value + '' == '0' ? '' : (this.innerNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.caseamountNrCls = this.caseamountNr.value + '' === '1' ? '' : (this.caseamountNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.casespreadNrCls = this.casespreadNr.value + '' === '1' ? '' : (this.casespreadNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.casestackNrCls = this.casestackNr.value + '' === '1' ? '' : (this.casestackNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.pcsbarcodeTxCls = this.pcsbarcodeTx.value === '' ? '' : (this.pcsbarcodeTx.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.casebarcodeTxCls = this.casebarcodeTx.value === '' ? '' : (this.casebarcodeTx.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.lengthNrCls = this.lengthNr.value + '' === '0' ? '' : (this.lengthNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.widthNrCls = this.widthNr.value + '' === '0' ? '' : (this.widthNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.heightNrCls = this.heightNr.value + '' === '0' ? '' : (this.heightNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.volumeNrCls = this.volumeNr.value + '' === '' ? '' : (this.volumeNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.weightNrCls = this.weightNr.value + '' === '0' ? '' : (this.weightNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.innerlengthNrCls = this.innerlengthNr.value + '' === '0' ? '' : (this.innerlengthNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.innerwidthNrCls = this.innerwidthNr.value + '' === '0' ? '' : (this.innerwidthNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.innerheightNrCls = this.innerheightNr.value + '' === '0' ? '' : (this.innerheightNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.caselengthNrCls = this.caselengthNr.value + '' === '0' ? '' : (this.caselengthNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.casewidthNrCls = this.casewidthNr.value + '' === '0' ? '' : (this.casewidthNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.caseheightNrCls = this.caseheightNr.value + '' === '0' ? '' : (this.caseheightNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.casevolumeNrCls = this.casevolumeNr.value + '' === '' ? '' : (this.casevolumeNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.caseweightNrCls = this.caseweightNr.value + '' === '0' ? '' : (this.caseweightNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.typeunitpriceCdCls = this.typeunitpriceCd.value === '10' ? '' : (this.typeunitpriceCd.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.stockunitpriceNrCls = this.stockunitpriceNr.value + '' === '0' ? '' : (this.stockunitpriceNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.arriveunitpriceNrCls = this.arriveunitpriceNr.value + '' === '0' ? '' : (this.arriveunitpriceNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.shipunitpriceNrCls = this.shipunitpriceNr.value + '' === '0' ? '' : (this.shipunitpriceNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.depositpriceNrCls = this.depositpriceNr.value + '' === '0' ? '' : (this.depositpriceNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.bsupppointbaraNrCls = this.bsupppointbaraNr.value + '' === '0' ? '' : (this.bsupppointbaraNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.bsupplimitbaraNrCls = this.bsupplimitbaraNr.value + '' === '9999' ? '' : (this.bsupplimitbaraNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.supppointinnercaseNrCls = this.supppointinnercaseNr.value + '' === '0' ? '' : (this.supppointinnercaseNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.supplimitinnercaseNrCls = this.supplimitinnercaseNr.value + '' === '9999' ? '' : (this.supplimitinnercaseNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.supppointcaseNrCls = this.supppointcaseNr.value + '' === '0' ? '' : (this.supppointcaseNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.supplimitcaseNrCls = this.supplimitcaseNr.value + '' === '9999' ? '' : (this.supplimitcaseNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.variation1TxCls = this.variation1Tx.value + '' === '' ? '' : (this.variation1Tx.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.variation2TxCls = this.variation2Tx.value + '' === '' ? '' : (this.variation2Tx.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.variation3TxCls = this.variation3Tx.value + '' === '' ? '' : (this.variation3Tx.errors == null ? this.STRINGS_ACTIVE : 'error');
    this.displaypriceNrCls = this.displaypriceNr.value + '' === '0' ? '' : (this.displaypriceNr.errors == null ? this.STRINGS_ACTIVE : 'error');
    
    this.volumeNr.setValue(this.getVolumeNr());
    this.casevolumeNr.setValue(this.getCaseVolumeNr());
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
      this.ownerId.value !== '' && this.ownerId.errors == null &&
      this.itemCd.value.length > 0 && this.itemCd.errors == null &&
      this.itemTx.value.length > 0 && this.itemTx.errors == null &&
      (this.arriveuselimitNr.value + '').length > 0 && this.arriveuselimitNr.errors == null &&
      (this.caseamountNr.value + '').length > 0 && this.caseamountNr.errors == null &&
      (this.pycaseamountNr.value + '').length > 0 && this.pycaseamountNr.errors == null &&
      (this.bybaracaseamountNr.value + '').length > 0 && this.bybaracaseamountNr.errors == null &&
      (this.bycaseamountNr.value + '').length > 0 && this.bycaseamountNr.errors == null &&
      (this.inneramountNr.value + '').length > 0 && this.inneramountNr.errors == null &&
      (this.innerNr.value + '').length > 0 && this.innerNr.errors == null &&
      (this.casespreadNr.value + '').length > 0 && this.casespreadNr.errors == null &&
      (this.casestackNr.value + '').length > 0 && this.casestackNr.errors == null &&
      (this.pcsbarcodeTx.value + '').length > 0 && this.pcsbarcodeTx.errors == null &&
      (this.shipuselimitNr.value + '').length > 0 && this.shipuselimitNr.errors == null &&
      (this.depositpriceNr.value + '').length > 0 && this.depositpriceNr.errors == null &&
      (this.displaypriceNr.value + '').length > 0 && this.displaypriceNr.errors == null &&
      (this.baraamountNr.value + '').length > 0 && this.baraamountNr.errors == null &&
      // (this.maxpbinstockNr.value + '').length > 0 && this.maxpbinstockNr.errors == null &&
      (this.bsupplimitbaraNr.value + '').length > 0 && this.bsupplimitbaraNr.errors == null &&
      (this.bsupppointbaraNr.value + '').length > 0 && this.bsupppointbaraNr.errors == null &&
      (this.supppointinnercaseNr.value + '').length > 0 && this.supppointinnercaseNr.errors == null &&
      (this.supplimitinnercaseNr.value + '').length > 0 && this.supplimitinnercaseNr.errors == null &&
      (this.supppointcaseNr.value + '').length > 0 && this.supppointcaseNr.errors == null &&
      (this.supplimitcaseNr.value + '').length > 0 && this.supplimitcaseNr.errors == null &&
      (this.stockunitpriceNr.value + '').length > 0 && this.stockunitpriceNr.errors == null &&
      (this.arriveunitpriceNr.value + '').length > 0 && this.arriveunitpriceNr.errors == null &&
      (this.shipunitpriceNr.value + '').length > 0 && this.shipunitpriceNr.errors == null &&
      this.casebarcodeTx.errors == null &&
      this.lengthNr.errors == null &&
      this.widthNr.errors == null &&
      this.heightNr.errors == null &&
      this.volumeNr.errors == null &&
      this.weightNr.errors == null &&
      this.innerlengthNr.errors == null &&
      this.innerwidthNr.errors == null &&
      this.innerheightNr.errors == null &&
      this.caselengthNr.errors == null &&
      this.casewidthNr.errors == null &&
      this.caseheightNr.errors == null &&
      this.casevolumeNr.errors == null &&
      this.caseweightNr.errors == null &&
      this.variation1Tx.errors == null &&
      this.variation2Tx.errors == null &&
      this.variation3Tx.errors == null

  }

  ngAfterViewInit() {
    this.scrollContent.nativeElement.addEventListener('scroll', event => {
      let scrollTop = event.target.scrollTop;
      if (this.anchors[1] > scrollTop) {
        this.tabIndex = 0;
      } else if (this.anchors[1] <= scrollTop && this.anchors[2] > scrollTop) {
        this.tabIndex = 1;
      } else {
        this.tabIndex = 2;
      }
    });
  }

  getVolumeNr() {
    let VolumeNr;
    VolumeNr = this.lengthNr.value * this.widthNr.value * this.heightNr.value * 0.000001;
    //小数点3まで四捨五入する
    VolumeNr = VolumeNr * 1000;
    VolumeNr = Math.round(VolumeNr) / 1000;
    return VolumeNr;
  }

  getCaseVolumeNr() {
    let caseVolumeNr;
    caseVolumeNr = this.caselengthNr.value * this.casewidthNr.value * this.caseheightNr.value * 0.000001;
    //小数点3まで四捨五入する
    caseVolumeNr = caseVolumeNr * 1000;
    caseVolumeNr = Math.round(caseVolumeNr) / 1000;
    return caseVolumeNr;
  }

  clrErr() {
    this.errorInfo = '';
  }

  changeOwnerId(){
    this.clrErr();
    let localOwnerId = this.selectedOwnerId ? this.selectedOwnerId : this.ownerId.value
    let ownerFunctionsArray = JSON.parse(sessionStorage.getItem('ownerFunctions')).ownerFunctions;
    this.isArrivlabeluseFl = this.commonService.isArrivlabeluseFl(ownerFunctionsArray,localOwnerId);
    this.isShiplabeluseFl = this.commonService.isShiplabeluseFl(ownerFunctionsArray,localOwnerId);

    // 選択した荷主の入荷ラベル運用フラグが0(false)であれば、入荷ラベル数量指定を0にする
    if(!(this.isArrivlabeluseFl)){
      this.arrivlabeluseFl = 0;
    }

    // 選択した荷主の出荷ラベル運用フラグが0(false)であれば、出荷ラベル印刷を0にする
    if(!(this.isShiplabeluseFl)){
      this.shiplabeluseFl = 0;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9101/wa9101.component.ts